module.exports = __webpack_public_path__ + "PY.png?d2261c0e70f1b77861138dbd07051c65";